export const CompetenciesData = [
  {
    id: 1,
    title: "Full Stack System Design & Scalable Architecture",
    detail: "End-to-end design of scalable, resilient platforms.",
    icon: <i className="fi fi-rr-layers"></i>,
  },
  {
    id: 2,
    title: "Backend Engineering",
    detail: "Node.js, FastAPI, REST APIs, and event-driven services.",
    icon: <i className="fi fi-rr-code-simple"></i>,
  },
  {
    id: 3,
    title: "AI Applications & LLM Integrations",
    detail: "RAG, agent workflows, and prompt engineering.",
    icon: <i className="fi fi-rr-brain-circuit"></i>,
  },
  {
    id: 4,
    title: "Distributed Systems & Data-Intensive Applications",
    detail: "High-volume, data-intensive distributed systems.",
    icon: <i className="fi fi-rr-network"></i>,
  },
  {
    id: 5,
    title: "API Design, Data Modeling & Database Optimization",
    detail: "Clean API contracts, data modeling, and query tuning.",
    icon: <i className="fi fi-rr-database"></i>,
  },
  {
    id: 6,
    title: "Cloud Native Development",
    detail: "AWS, GCP, and CI/CD pipelines.",
    icon: <i className="fi fi-rr-cloud"></i>,
  },
  {
    id: 7,
    title: "Performance Engineering & Reliability",
    detail: "Latency, throughput, and reliability tuning.",
    icon: <i className="fi fi-rr-bolt"></i>,
  },
  {
    id: 8,
    title: "AI Product Development & Intelligent Automation",
    detail: "Shipping AI-powered products and automation.",
    icon: <i className="fi fi-rr-microchip"></i>,
  },
  {
    id: 9,
    title: "Micro-Frontend & Modular Architecture",
    detail: "Decoupled, independently deployable modules.",
    icon: <i className="fi fi-rr-apps"></i>,
  },
  {
    id: 10,
    title: "Scalable & Performance-Optimized UI",
    detail: "Fast, responsive, high-performance interfaces.",
    icon: <i className="fi fi-rr-browser"></i>,
  },
];
